export type ColorsType = keyof typeof Colors;

export const Colors = {
  elmDarkest: '#12515b',
  elmDarker: '#16626e',
  elm: '#1d8292',
  elmLighter: '#afd8df',
  elmLightest: '#dfeff2',
  elmHyperlight: '#f3fafb',
  coralDarkest: '#88332e',
  coralDarker: '#a43d38',
  coral: '#da514a',
  coralLighter: '#ec7063',
  coralLightest: '#ffb4b0',
  coralHyperlight: '#ffe9e8',
  harvestGoldHyperLight: '#FFF6EF',
  harvestGold: '#E89E67',
  harvestGoldDarker: '#B65A20',
  hypnotiqRegular: '#3485C4',
  midnightRegular: '#264753',
  midnightLighter: '#657983',
  midnightLightest: '#92A3A9',
  midnightDarkest: '#13242a',
  midnightDarker: '#1A1919',
  neutralLow: '#F2F2F0',
  steelHyperdark: '#13242A',
  steelDarker: '#b9c3c7',
  steelDarkest: '#8f9fa5',
  steel: '#d3dadc',
  steelLighter: '#edf0f1',
  steelLightest: '#f6f7f8',
  sunDarkest: '#D2A30B',
  sunDarker: '#e5ae00',
  sun: '#ffe5a5',
  sunLighter: '#fff6df',
  sunLightest: '#FFFBF0',
  grass: '#16c483',
  grassDarkest: '#077757',
  grassMid: '#08b78d',
  grassLighter: '#A4E8D7',
  grassLightest: '#E8F9F2',
  meadowDarker: '#008861',
  meadow: '#15c483',
  meadowHyperLight: '#F4FCF8',
  skyDarker: '#3374A7',
  skyRegular: '#3485C3',
  skyLighter: '#88bce3',
  skyLightest: '#cde5f6',
  skyHyperLight: '#e6f2fa',
  rubyRed: '#e51717',
  rubyRedLight: '#ffe9e8',
  white: '#fff',
  textDefault: '#1A1919',
  darkGrey: '#737373',
};
